/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
import { Close } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import { SquareMenuIcon } from 'assets/icons';
import { ErrorMessage, PrimaryFilledTextField, PrimaryOutlinedButton } from 'components';
import {
  IGoal,
} from '../../../../../../interface';

interface GoalProps {
  handleChange:(index:number, goal:IGoal) =>void
  index:number,
  removeGoal:(index:number)=>void
  errors: any,
  goalInit:IGoal
}

export default function Goal({
  index, handleChange, removeGoal, errors, goalInit,
}:GoalProps) {
  const [goal,
    setGoal] = React.useState<IGoal>(
    goalInit,
  );
  // handle goal name
  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => setGoal({
    ...goal,
    title: event.target.value,
  });

  // handle badges
  const handleRemoveWrapper = () => {
    removeGoal(index);
  };

  React.useEffect(() => {
    handleChange(index, goal);
  }, [goal]);

  return (
    <div style={{
      background: '#FFF',
      border: '1px solid #E5E5E5',
      padding: '0 2rem',
      borderRadius: '5px',
    }}
    >
      <SquareMenuIcon sx={{ marginLeft: '-2rem' }} />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4">
            Goal #
            {index + 1}
          </Typography>

        </Grid>
        <Grid item xs="auto" alignItems="center" sx={{ color: '#E93E3E' }}>
          <Grid container alignItems="center">
            <Close />
            <PrimaryOutlinedButton onClick={handleRemoveWrapper}>Remove </PrimaryOutlinedButton>
          </Grid>

        </Grid>
      </Grid>
      <div style={{ width: '80%' }} className="form-item">
        <PrimaryFilledTextField placeholder="Name this goal" value={goal.title} max={50} onChange={handleName} />
        <ErrorMessage>
          {errors?.goals ? errors?.goals[index]?.title?.message : ''}

        </ErrorMessage>
      </div>

    </div>
  );
}
